var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceSegmentTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.11816H3.5C2.39543 1.11816 1.5 2.0136 1.5 3.11816V17.8821C1.5 19.3689 3.06462 20.3359 4.39443 19.6709L4.60557 19.5654C5.16863 19.2838 5.83137 19.2838 6.39443 19.5654L8.60557 20.6709C9.16863 20.9525 9.83137 20.9525 10.3944 20.6709L12.6056 19.5654C13.1686 19.2838 13.8314 19.2838 14.3944 19.5654L14.6056 19.671C15.9354 20.3359 17.5 19.3689 17.5 17.8821V3.11816C17.5 2.01359 16.6046 1.11816 15.5 1.11816Z",
    fill: "#E5E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.11816H13.5M5.5 9.11816H13.5M5.5 13.1182H13.5M3.5 1.11816H15.5C16.6046 1.11816 17.5 2.01359 17.5 3.11816V17.8821C17.5 19.3689 15.9354 20.3359 14.6056 19.671L14.3944 19.5654C13.8314 19.2838 13.1686 19.2838 12.6056 19.5654L10.3944 20.6709C9.83137 20.9525 9.16863 20.9525 8.60557 20.6709L6.39443 19.5654C5.83137 19.2838 5.16863 19.2838 4.60557 19.5654L4.39443 19.6709C3.06462 20.3359 1.5 19.3689 1.5 17.8821V3.11816C1.5 2.0136 2.39543 1.11816 3.5 1.11816Z",
    stroke: "#8278F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceSegmentTab);
export default __webpack_public_path__ + "static/media/price_segment_tab.7aa161c7c5605173f736667dfe90e16f.svg";
export { ForwardRef as ReactComponent };